export const DOT_R = 12;